module.exports = __webpack_public_path__ + "img/BELogoUpdated@2x.646dc4c0.png";